import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Check,
  DollarSign,
  Download,
  Plus,
  Save,
  Upload,
  X,
} from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { currencyContains } from "../../api/currencyApi";
import {
  addAndUpload,
  deleteDocumentList,
  getDocumentByOpeAndRef,
  updateAndUpload,
} from "../../api/documentUpload";
import {
  getAllCharges,
  getExchangeSelectionValues,
  getJobInfo,
  getTemplateDetails,
  saveTemplate,
} from "../../api/finance/addChargesApi";
import {
  approveEvInvInAdHoc,
  saveEvInvInAdHoc,
} from "../../api/finance/chargeConfirmation";
import { getBulkDropdownData } from "../../api/keyvalue";
import DocumentUpload from "../../components/DocumentUpload";
import Grid from "../../components/Grid";
import InfoList from "../../components/InfoList";
import LoadingSpinner from "../../components/LoadingSpinner";
import Modal from "../../components/Modal";
import Button from "../../components/input/Button";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import SearchDropdown from "../../components/input/SearchDropdown";
import ButtonRenderer from "../../components/renderer/ButtonRenderer";
import SelectRenderer from "../../components/renderer/SelectRenderer";
import {
  DynamicCurrencyRenderer,
  ResizableScrollingTextRenderer,
} from "../../components/renderer/StyleRenderer";
import { chargeTemplateCreationValidation } from "../../components/validations/ChargeCreation";
import { AUTH_TYPES, AUTHORITY_TYPE, FORMS, MODULES } from "../../const";
import { isNumber } from "../../helper";
import useUserCompany from "../../hooks/useUserCompany";
import JobMonitorReportComponent from "../../components/transaction/JobMonitor/JobMonitorReportComponent";
import { MdApproval } from "react-icons/md";
import { reportActions } from "../../store/report/report-slice";
import ChargeTaxBreakdown from "../../components/finance/EvInv/ChargeTaxBreakdown";

const mode = {
  CREATE: 1,
  EDIT: 2,
};

const fieldPermissions = {
  CURRENCY: "currency",
  SAVE_TEMPLATE: "saveTemplate",
};

const HEADER_FORM = FORMS.CHARGE_CREATION.HEADER.form;
const DETAIL_FORM = FORMS.CHARGE_CREATION.DETAILS.form;

const JobMonitorEvInvCreation = ({
  jobId,
  template,
  editMode,
  handleDrawerClose,
  approvalMode,
  evInv,
  modeObj,
  evInvDetails,
  setUpdateNeeded,
}) => {
  const user = useSelector((state) => state.user);
  const auth = useSelector((state) => state.user.permissions[MODULES.Finance]);
  const userCompany = useUserCompany();
  const userCurrency = userCompany ? userCompany.comCurrency : null;
  const userCurrencyCode = userCompany ? userCompany.comCurrencyCode : null;
  const userCurrencyName = userCompany ? userCompany.comCurrencyName : null;
  const chargeDetailPermissions = auth?.[DETAIL_FORM];
  // const chargeHeaderPermissions = auth?.[HEADER_FORM];
  // const approveEditPermission = chargeDetailPermissions?.FORM?.EDIT_APPROVED;
  const saveAsTemplatePermission =
    chargeDetailPermissions?.[fieldPermissions.SAVE_TEMPLATE]?.VIEW;
  const containsAnyGridPermissions = () => {
    console.log(chargeDetailPermissions);
    const gridPermissionKeys = chargeDetailPermissions
      ? Object.keys(chargeDetailPermissions).filter(
          (permission) =>
            permission !== "FORM" &&
            permission !== fieldPermissions.CURRENCY &&
            permission !== fieldPermissions.SAVE_TEMPLATE,
        )
      : [];
    return gridPermissionKeys.length > 0;
  };
  const [drawerTab, setDrawerTab] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isBlurred, setIsBlurred] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isJobInfoLoading, setIsJobInfoLoading] = useState(false);
  const [rowCount, setRowCount] = useState(2);
  const [templateDetailsLoading, setTemplateDetailsLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const dispatch = useDispatch();

  const [chargeOpt, setChargeOpt] = useState("");
  const [revCostOpt, setRevCostOpt] = useState("");
  const [statusOpt, setStatusOpt] = useState("");
  const [activeOpt, setActiveOpt] = useState("");
  const [uomOpt, setUomOpt] = useState("");
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [fileNameOptions, setFileNameOptions] = useState([]);

  const [jobData, setJobData] = useState({});
  const [JobSummary, setJobSummary] = useState([]);
  const [currency, setCurrency] = useState(userCurrency);
  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [chargeHeader, setChargeHeader] = useState({});

  const gridRef = useRef(null);
  const [customerSupplierOpt, setCustomerSupplierOpt] = useState([]);
  const [savingTemplate, setSavingTemplate] = useState(false);
  const [category, setCategory] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [templateDescription, setTemplateDescription] = useState("");
  const [currentErrors, setCurrentErrors] = useState({});
  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null,
  );
  const [exchangeRates, setExchangeRates] = useState([]);
  const modal2Ref = useRef();
  const [rowData, setRowData] = useState({});
  const [exchangeRate, setExchangeRate] = useState({});
  const documentRef = useRef(null);
  const [documents, setDocuments] = useState([]);
  const [approveStatus, setApproveStatus] = useState(1);

  const [evInvNo, setEvInvNo] = useState("");
  const [createdDate, setCreatedDate] = useState("");
  const [reference, setReference] = useState("");
  const [tax, setTax] = useState("");
  const [withoutTax, setWithoutTax] = useState("");
  const [total, setTotal] = useState("");
  const modal3Ref = useRef(null);
  const [selectedCharge, setSelectedCharge] = useState({
    jobEvInvoicesTaxDetailList: {},
  });
  const [focRev, setFocRev] = useState(false);
  const [focCost, setFocCost] = useState(false);

  // const evInvApprovalDetailPermission =
  //   auth[FORMS?.EV_INV_APPROVAL?.DETAILS?.form];

  const closeModal2 = () => {
    modal2Ref.current.close();
  };

  const openModal2 = () => {
    modal2Ref.current?.showModal();
  };

  useEffect(() => {
    setCurrency(userCurrency);
  }, [userCurrency]);

  useEffect(() => {
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);

  useEffect(() => {
    (async () => {
      setIsJobInfoLoading(true);
      const response = await getJobInfo(jobId);
      const jobInfoData = response ? response[0] : {};
      setFocRev(jobInfoData?.jobFocRev ? jobInfoData.jobFocRev : false);
      setFocCost(jobInfoData?.jobFocCost ? jobInfoData.jobFocCost : false);
      const jobInfoObject = [
        {
          title: "Job Code",
          value: jobInfoData?.jobCode ? jobInfoData.jobCode : "N/A",
        },
        {
          title: "Request Code",
          value: jobInfoData?.reqCode ? jobInfoData.reqCode : "N/A",
        },
        {
          title: "Customer",
          value: jobInfoData?.customerName ? jobInfoData.customerName : "N/A",
        },
        {
          title: "Currency",
          value: (
            <SearchDropdown
              key={1}
              authenticated={true}
              module={MODULES.Finance}
              form={DETAIL_FORM}
              field={fieldPermissions.CURRENCY}
              defaultValue={userCurrencyName}
              reset={searchFieldReset}
              setReset={setSearchFieldReset}
              onResultSelect={(data) => setCurrency(data)}
              api={currencyContains}
              fieldInfo={{
                tableName: "masterdata.tms_vm_reg_currency",
                primaryKey: "cur_id",
                fieldName: "cur_currency",
                id: currency,
              }}
              readOnly={true}
            />
          ),
        },
        {
          title: "Shipper",
          value: jobInfoData?.shipperName ? jobInfoData.shipperName : "N/A",
        },
        {
          title: "Billing Customer",
          value: jobInfoData?.billinCustomer
            ? jobInfoData.billinCustomer
            : "N/A",
        },
        {
          title: "Invoicing Customer",
          value: jobInfoData?.invoicingCustomer
            ? jobInfoData.invoicingCustomer
            : "N/A",
        },
        {
          title: "Vehicle No",
          value: jobInfoData?.vehVehicleno ? jobInfoData.vehVehicleno : "N/A",
        },
        {
          title: "Transporter",
          value: jobInfoData?.transporterName
            ? jobInfoData.transporterName
            : "N/A",
        },
        {
          title: "Rate Type",
          value: jobInfoData?.rateType ? jobInfoData.rateType : "N/A",
        },
        {
          title: "VHT Type",
          value: jobInfoData?.vhtType ? jobInfoData.vhtType : "N/A",
        },
        {
          title: "Negotiation",
          value: jobInfoData?.negotiation ? jobInfoData.negotiation : "N/A",
        },
        {
          title: "Container Nos",
          value: jobInfoData?.conNumbers,
        },
      ];

      setJobSummary(jobInfoObject);
      setJobData(jobInfoData);

      if (approvalMode) {
        const formatToTwoDecimalPlaces = (value) => {
          if (value == null || value === "N/A") {
            return "N/A";
          }
          const num = parseFloat(value);
          const ceiledNum = isNaN(num) ? "N/A" : num.toFixed(2);
          const formatter = Intl.NumberFormat("en-US", {
            style: "currency",
            currency: userCurrencyCode,
          });

          return formatter.format(ceiledNum);
        };

        setApproveStatus(evInvDetails?.eihStatus);
        setEvInvNo(evInvDetails?.eihCode);
        setCreatedDate(
          new Date(evInvDetails?.createdDate).toISOString().split("T")[0],
        );
        setReference(evInvDetails?.eihReferance);
        setTotal(
          evInvDetails?.eihWithTax
            ? formatToTwoDecimalPlaces(evInvDetails?.eihWithTax)
            : formatToTwoDecimalPlaces(0),
        );
        setWithoutTax(
          evInvDetails?.eihWithoutTax
            ? formatToTwoDecimalPlaces(evInvDetails?.eihWithoutTax)
            : formatToTwoDecimalPlaces(0),
        );
        const totalTax = evInvDetails?.eihWithTax - evInvDetails?.eihWithoutTax;
        setTax(
          totalTax
            ? formatToTwoDecimalPlaces(totalTax)
            : formatToTwoDecimalPlaces(0),
        );

        let currentCharges = [];
        let id = 2;

        for (let item of evInvDetails?.jobEvInvoiceDetails) {
          currentCharges.push({
            id: id++,
            chdId: null,
            chdCharge: item?.eidId,
            chdChacrges: item?.eidCharge,
            chdDescription: item?.eidDescription,
            chdCurrency: item?.eidCurrency,
            chdTotal: item?.eidTotal,
            chdExcId: item?.eidExcId,
            chdExcCurrency: {
              excId: item.eidExcId ? item.eidExcId : -1,
              excRate: item.eidExcRate ? item.eidExcRate : 1,
              curCode: item.eidCurCode ? item.eidCurCode : "",
            },
            curCode: item?.eidCurCode ? item.eidCurCode : "",
            chdValue: item?.eidValue,
            chdQty: item?.eidQty,
            chdUom: item?.eidUom,
            chdActive: item?.eidActive,
            chdStatus: item?.eidStatus,
            chdChargeType: evInv === modeObj.EV ? 2 : 1,
            chdTax: item?.eidTax,
            chdTaxAmount: item?.eidTaxAmount,
            taxList: item?.jobEvInvoicesTaxDetailList,
          });
        }

        setRowCount(id);
        setGridData(currentCharges);

        const documents = await getDocumentByOpeAndRef(17, evInvDetails?.eihId);
        setDocuments(documents);
      }

      setIsJobInfoLoading(false);
    })();
  }, [jobId, approvalMode, evInvDetails]);

  const handleSelectionChanged = useCallback(() => {
    const selectedData = gridRef.current.getSelectedData();
    setSelectedRows(selectedData);
  }, []);

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      const exchangeSelection = await getExchangeSelectionValues({
        baseCurrency: currency,
        headerId: approvalMode ? evInvDetails?.eihId : -1,
        currency: null,
        bank: null,
        branch: null,
        user: user.username,
        company: company,
      });

      console.log("exchangeSelection", exchangeSelection);
      setExchangeRates(exchangeSelection);

      const charges = await getAllCharges();
      setChargeOpt(charges);

      const {
        status,
        active,
        revcost: revCost,
        uom,
        rate_type_for: rateTypes,
        doc_type: docTypeData,
        "file_name#15": fileNameData,
      } = await getBulkDropdownData([
        { key: "status" },
        { key: "active" },
        { key: "revcost" },
        { key: "uom" },
        { key: "rate_type_for" },
        { key: "doc_type" },
        { key: "file_name", group: "15" },
      ]);
      if (focRev && focCost) {
        setRevCostOpt([]);
      } else if (focCost) {
        const focCostOption = revCost?.filter((option) => option.key !== 2);
        setRevCostOpt(focCostOption);
      } else if (focRev) {
        const focRevOption = revCost?.filter((option) => option.key !== 1);
        setRevCostOpt(focRevOption);
      } else {
        setRevCostOpt(revCost);
      }
      setUomOpt(uom);
      setStatusOpt(status);
      setActiveOpt(active);
      setCustomerSupplierOpt(rateTypes);
      setDocumentTypeOptions(docTypeData);
      setFileNameOptions(fileNameData);
      setIsLoading(false);
    })();
  }, [currency, jobId, user, company, approvalMode]);

  useEffect(() => {
    if (!approvalMode) {
      (async () => {
        setTemplateDetailsLoading(true);
        const parsedValue =
          exchangeRates.length > 0 ? JSON.parse(exchangeRates[0]?.value) : null;
        console.log("parsedValue", parsedValue);

        const templateData = await getTemplateDetails(template);
        console.log("templateData", templateData);

        if (templateData?.length > 0) {
          const data = templateData?.map((item, index) => {
            return {
              id: index,
              chdChacrges: item.chtId,
              chdDescription: item.incDescription,
              chdExcCurrency: exchangeRates[0]?.key === -1 ? parsedValue : {},
              chdExcId: exchangeRates[0]?.key === -1 ? parsedValue.excId : null,
              chdExcRate:
                exchangeRates[0]?.key === -1 ? parsedValue.excRate : null,
              value: null,
              chdQty: 1,
              chdTotal: null,
              chdSavedTotal: 0,
              chdUom: 1,
              chdStatus: 2,
              chdActive: 1,
              chdChargeType: evInv === modeObj?.EV ? 2 : 1,
              mode: mode.CREATE,
            };
          });
          setGridData(data);
          setRowCount(data.length);
        } else {
          setGridData([]);
          setRowCount(2);
        }
        setTemplateDetailsLoading(false);
      })();
    }
  }, [template, exchangeRates, approvalMode]);

  const handleAddRow = () => {
    const parsedValue =
      exchangeRates.length > 0 ? JSON.parse(exchangeRates[0]?.value) : null;
    let currentRowCount = rowCount + 1;
    const newRow = {
      id: currentRowCount,
      chdChacrges: null,
      chdDescription: "",
      chdExcCurrency: exchangeRates[0]?.key === -1 ? parsedValue : {},
      chdExcId: exchangeRates[0]?.key === -1 ? parsedValue.excId : null,
      chdExcRate: exchangeRates[0]?.key === -1 ? parsedValue.excRate : null,
      chdValue: null,
      chdQty: 1,
      chdTotal: null,
      chdSavedTotal: 0,
      chdUom: 1,
      chdStatus: 2,
      chdActive: 1,
      chdChargeType: evInv === modeObj.EV ? 2 : 1,
      mode: mode.CREATE,
    };

    setGridData([...gridData, newRow]);
    setRowCount(currentRowCount);
  };

  console.log("EvInv", evInv);

  const cellEditorParams = (params) => {
    if (approvalMode) return;

    switch (params.colDef.field) {
      case "chdValue": {
        let value = Math.abs(Number(params.value));
        setGridData((prev) =>
          prev.map((row) => {
            if (row.id === params.data.id) {
              if (row.persisted) {
                return {
                  ...row,
                  chdValue: value,
                  chdTotal: params.data.chdQty * value * params.data.chdExcRate,
                  mode: mode.EDIT,
                };
              } else {
                return {
                  ...row,
                  chdValue: value,
                  chdTotal: params.data.chdQty * value * params.data.chdExcRate,
                };
              }
            }
            return row;
          }),
        );
        break;
      }
      case "chdQty": {
        let value = Math.abs(Number(params.value));
        setGridData((prev) =>
          prev.map((row) => {
            if (row.id === params.data.id) {
              if (row.persisted) {
                return {
                  ...row,
                  chdQty: value,
                  chdTotal:
                    params.data.chdValue * value * params.data.chdExcRate,
                  mode: mode.EDIT,
                };
              } else {
                return {
                  ...row,
                  chdQty: value,
                  chdTotal:
                    params.data.chdValue * value * params.data.chdExcRate,
                };
              }
            }
            return row;
          }),
        );
        break;
      }
      case "chdDescription": {
        setGridData((prev) =>
          prev.map((row) => {
            if (row.id === params.data.id) {
              if (row.persisted) {
                return {
                  ...row,
                  chdDescription: params.value,
                  mode: mode.EDIT,
                };
              } else {
                return {
                  ...row,
                  chdDescription: params.value,
                };
              }
            }
            return row;
          }),
        );
        break;
      }

      default:
    }
  };

  const resetForm = () => {
    setGridData([]);
    setSelectedRows([]);
    setRowCount(2);
    setEvInvNo("");
    setCreatedDate("");
    setReference("");
    setApproveStatus(1);
    setTax("");
    setWithoutTax("");
    setTotal("");
  };

  const chargeValidator = () => {
    let isValid = true;
    for (let row of selectedRows) {
      if (row.chdChacrges === null) {
        isValid = false;
        break;
      }
      // if (row.chdChargeType === null) {
      //   isValid = false;
      //   break;
      // }
      if (row.chdExcId === null) {
        isValid = false;
        break;
      }
      if (row.chdValue === null) {
        isValid = false;
        break;
      }
      // if (row.chdQty === null) {
      //   isValid = false;
      //   break;
      // }
      // if (row.chdUom === "") {
      //   isValid = false;
      //   break;
      // }
      // if (row.chdStatus === "") {
      //   isValid = false;
      //   break;
      // }
      // if (row.chdActive === "") {
      //   isValid = false;
      //   break;
      // }
    }
    return isValid;
  };

  const qtyAndValueValidator = () => {
    let isValid = true;
    for (let row of selectedRows) {
      if (row.chdValue < 0) {
        isValid = false;
        break;
      }
      if (row.chdQty <= 0) {
        isValid = false;
        break;
      }
    }
    return isValid;
  };

  const approveEvInvInAdHocManner = async (e) => {
    e.preventDefault();
    if (approveStatus !== 1) {
      try {
        setIsSubmitLoading(true);
        setIsBlurred(true);
        const data = {
          eihId: evInvDetails?.eihId,
          status: approveStatus,
          author: user.username,
          referance: reference,
        };
        const response = await approveEvInvInAdHoc(data);
        if (response?.status === 200) {
          const documents = documentRef.current.getData();
          for (let doc of documents.created) {
            const { file, ...rest } = doc;
            const formData = new FormData();
            formData.append("multipartFile", doc.file);
            formData.append("documentRequest", JSON.stringify(rest));
            formData.append("isImage", rest.docCategory === 1);
            const res = await addAndUpload(formData);
            if (res && res?.responseCode === "2040") {
              toast.success(res?.message, {
                autoClose: 5000,
                containerId: "Main",
              });
            } else {
              toast.error(
                res?.message || `Error adding document ${doc.docName}`,
                {
                  autoClose: 5000,
                  containerId: "Main",
                },
              );
            }
          }

          for (let doc of documents.modified) {
            const { file, ...rest } = doc;
            const formData = new FormData();
            formData.append("multipartFile", doc.file);
            formData.append("documentRequest", JSON.stringify(rest));
            formData.append("isImage", rest.docCategory === 1);
            const res = await updateAndUpload(formData);
            if (res && res?.responseCode === "2040") {
              toast.success(res?.message, {
                autoClose: 5000,
                containerId: "Main",
              });
            } else {
              toast.error(
                res?.message || `Error updating document ${doc.docName}`,
                {
                  autoClose: 5000,
                  containerId: "Main",
                },
              );
            }
          }

          if (documents?.deleted.length > 0) {
            await deleteDocumentList({
              docIdList: documents?.deleted,
            });
            toast.success("Documents deleted successfully!", {
              autoClose: 5000,
              containerId: "Main",
            });
          }

          if (approveStatus === 2) {
            toast.success(response?.data + " Approved successfully!", {
              autoClose: 5000,
              containerId: "Main",
            });
          } else if (approveStatus === 3) {
            toast.success(response?.data + " Rejected successfully!", {
              autoClose: 5000,
              containerId: "Main",
            });
          }
          resetForm();
          handleDrawerClose();
          setIsBlurred(false);
          setUpdateNeeded(true);
        } else {
          toast.error("Something went wrong. please try again..", {
            autoClose: 5000,
            containerId: "Main",
          });
          setIsBlurred(false);
          setIsSubmitLoading(false);
        }
        setIsBlurred(false);
        setIsSubmitLoading(false);
      } catch (e) {
        console.error(e);
        setIsBlurred(false);
        setIsSubmitLoading(false);
      }
    }
  };

  const generateEvInvInAdHoc = async (e) => {
    e.preventDefault();
    setIsSubmitLoading(true);
    setIsBlurred(true);

    try {
      if (selectedRows?.length === 0) {
        toast.error("Please add charges", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsSubmitLoading(false);
        setIsBlurred(false);
        return;
      }

      if (!chargeValidator()) {
        toast.error("Please fill all the fields in the grid", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsSubmitLoading(false);
        setIsBlurred(false);
        return;
      }

      if (!qtyAndValueValidator()) {
        toast.error("Qty and value should be greater than 0", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsSubmitLoading(false);
        setIsBlurred(false);
        return;
      }

      const response = await saveEvInvInAdHoc(
        {
          jobChargeHeader: {
            chhReferance: reference,
            chhCompany: company,
            chhRequest: jobData.jobRequest,
            chhJobId: jobData.jobId,
            chhCustomer: jobData.customerId,
            chhSupplier: jobData.transId,
            chhVehicle: jobData.jobVehicle,
            chhKm: jobData.chargeableValue,
            chhRevenue: selectedRows?.reduce((acc, item) => {
              if (item.chdStatus === 2) {
                if (parseInt(item.chdChargeType) === 1) {
                  return acc + item.chdTotal;
                }
              }
              return acc;
            }, 0),
            chhCost: selectedRows?.reduce((acc, item) => {
              if (item.chdStatus === 2) {
                if (parseInt(item.chdChargeType) === 2) {
                  return acc + item.chdTotal;
                }
              }
              return acc;
            }, 0),
            chhCurrency: currency,
            chhExchangeRate: null,
            chhDescription1: "",
            chhDescription2: "",
            chhFormDate: jobData.fromDate,
            chhToDate: jobData.toDate,
            chhEvStatus: evInv === modeObj.EV ? 2 : 1,
            chhInvStatus: evInv === modeObj.INV ? 2 : 1,
            chhStatus: 2,
            chhActive: 1,
          },
          jobChargeDetails: selectedRows?.map((item) => ({
            chdCompany: company,
            chdChargeType: item.chdChargeType,
            chdChacrges: parseInt(item.chdChacrges),
            chdValue: item.chdValue,
            chdCurrency: currency,
            chdQty: item.chdQty,
            chdDescription: item.chdDescription,
            chdExcId: item.chdExcId,
            chdExcRate: item.chdExcRate,
            chdUom: item.chdUom,
            chdTotal: item.chdTotal,
            chdStatus: item.chdStatus,
            chdActive: item.chdActive,
          })),
          author: user.username,
        },
        evInv === modeObj.EV ? 2 : 1,
      );

      console.log("eidResponse", response);

      if (response?.status === 201) {
        const documents = documentRef.current.getData();
        if (documents.length > 0) {
          for (let doc of documents) {
            const { file, ...rest } = doc;
            const formData = new FormData();
            formData.append("multipartFile", doc.file);
            formData.append(
              "documentRequest",
              JSON.stringify({
                ...rest,
                docReference: response?.data.eihId,
              }),
            );
            formData.append("isImage", rest.docCategory === 1);
            const res = await addAndUpload(formData);
            if (res && res?.responseCode === "2040") {
              toast.success(res?.message, {
                autoClose: 5000,
                containerId: "Main",
              });
            } else {
              toast.error(
                res?.message || `Error adding document ${doc.docName}`,
                {
                  autoClose: 5000,
                  containerId: "Main",
                },
              );
            }
          }
        }

        toast.success(response?.data.eihCode + " generated successfully!", {
          autoClose: 5000,
          containerId: "Main",
        });

        resetForm();
        handleDrawerClose();
        setIsSubmitLoading(false);
        setIsBlurred(false);
      }
    } catch (e) {
      console.error(e);
      if (e?.response?.data) {
        toast.error(e.response.data, {
          autoClose: 5000,
          containerId: "Main",
        });
      } else {
        toast.error("Something went wrong. Please try again !", {
          autoClose: 5000,
          containerId: "Main",
        });
      }
    } finally {
      setIsSubmitLoading(false);
      setIsBlurred(false);
    }
  };

  const modalRef = useRef();
  const openModal = () => {
    modalRef.current?.showModal();
  };

  const closeModal = () => {
    modalRef.current.close();
  };

  const saveAsTemplate = async (e) => {
    e.preventDefault();
    setSavingTemplate(true);

    const templateErrors = chargeTemplateCreationValidation({
      intTemplateName: templateName,
      intCategory: category,
    });

    if (Object.keys(templateErrors).length > 0) {
      setCurrentErrors(templateErrors);
      document.querySelector(".ui.form").classList.add("error");
      toast.error("please Fill the required fields", {
        autoClose: 5000,
        containerId: "Main",
      });
      setSavingTemplate(false);
      return;
    } else {
      setCurrentErrors({});
      document.querySelector(".ui.form").classList.remove("error");

      for (let row of selectedRows) {
        if (row.chdChacrges === "") {
          toast.error("Please select charges for all rows", {
            autoClose: 5000,
            containerId: "Main",
          });
          setSavingTemplate(false);
          return;
        }
      }

      const response = await saveTemplate({
        chargeTemplateRequest: {
          intTemplateName: templateName,
          intCategory: category,
          intDescription: templateDescription,
          intStatus: 2,
          intActive: 1,
          intStakeholder: null,
        },
        templateChargesRequests: selectedRows?.map((item, index) => ({
          incCharge: item.chdChacrges,
          incDescription: item.chdDescription,
          incStatus: 2,
          incActive: 1,
          incSeq: index + 1,
          incChgType: item.chdChargeType,
        })),
        author: user.username,
      });

      if (response.status === 201) {
        toast.success(response.data + " !", {
          autoClose: 5000,
          containerId: "Main",
        });
      } else {
        toast.error(response.data, { autoClose: 5000, containerId: "Main" });
      }
    }

    // setUpdateTemplates(!updateTemplates);
    closeModal();
    setSavingTemplate(false);
  };

  const getConfig = () => {
    const configData = [
      {
        headerName: "Charge",
        field: "chdChacrges",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellRenderer: SelectRenderer,
        cellRendererParams: (params) => ({
          onChangeHandler: (data) => {
            setGridData((prev) =>
              prev.map((item) => {
                if (item.id === params.data.id) {
                  if (item.persisted) {
                    return {
                      ...item,
                      chdChacrges: data,
                      mode: mode.EDIT,
                    };
                  } else {
                    return {
                      ...item,
                      chdChacrges: data,
                    };
                  }
                }
                return item;
              }),
            );
          },
          options: chargeOpt,
          placeholder: "Select Charge",
          module: MODULES.Finance,
          form: DETAIL_FORM,
          field: "chdChacrges",
          authenticated: true,
          value: params.data.chdChacrges,
          disabled: approvalMode,
          searchable: true,
        }),
      },
      {
        headerName: "Charge Type",
        field: "chdChargeType",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellRenderer: SelectRenderer,
        cellRendererParams: (params) => {
          return {
            module: MODULES.Finance,
            form: DETAIL_FORM,
            field: "chdChargeType",
            authenticated: true,
            options: revCostOpt,
            placeholder: "Select Charge Type",
            value: params.data.chdChargeType,
            // disabled: isDisabled(params),
            disabled: true,
          };
        },
      },
      {
        headerName: "Description",
        field: "chdDescription",
        cellEditor: "agTextCellEditor",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellEditorParams: {
          maxLength: 100,
        },
        tooltipValueGetter: (params) => {
          return "press Enter to set the value";
        },
        editable: true,
        cellRenderer: ResizableScrollingTextRenderer,
        minWidth: 300,
      },
      {
        headerName: "Currency",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        field: "chdExcCurrency.curCode",
        cellRenderer: ResizableScrollingTextRenderer,
        tooltipValueGetter: (params) => {
          return "Double click to set the currency";
        },
        disabled: approvalMode,
      },
      {
        headerName: "Value",
        field: "chdValue",
        cellEditor: "agNumberCellEditor",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        editable: true,
        tooltipValueGetter: (params) => {
          return "press Enter to set the value";
        },
        valueFormatter: (params) => {
          const value = params.value || 0;
          return value.toFixed(2); // Always display with 2 decimal places
        },
      },
      {
        headerName: "Qty",
        field: "chdQty",
        cellEditor: "agNumberCellEditor",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        tooltipValueGetter: (params) => {
          return "press Enter to set the value";
        },
        editable: true,
        // valueFormatter: (params) => {
        //   const value = params.value || 1; //
        //   return value.toFixed(2); // Always display with 2 decimal places
        // },
      },
      {
        headerName: "Total",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        field: "chdTotal",
        valueFormatter: (params) => {
          const value = params.value || 0;
          return value.toFixed(2); // Always display with 2 decimal places
        },
      },
      {
        headerName: "UOM",
        field: "chdUom",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellRenderer: SelectRenderer,
        cellRendererParams: (params) => ({
          onChangeHandler: (data) => {
            setGridData((prev) =>
              prev.map((item) => {
                if (item.id === params.data.id) {
                  if (item.persisted) {
                    return {
                      ...item,
                      chdUom: data,
                      mode: mode.EDIT,
                    };
                  } else {
                    return {
                      ...item,
                      chdUom: data,
                    };
                  }
                }
                return item;
              }),
            );
          },
          options: uomOpt,
          placeholder: "Select UOM",
          module: MODULES.Finance,
          form: DETAIL_FORM,
          field: "chdUom",
          authenticated: true,
          value: params.data.chdUom,
          disabled: approvalMode,
        }),
      },
      {
        headerName: "Status",
        field: "chdStatus",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellRenderer: SelectRenderer,
        cellRendererParams: (params) => ({
          onChangeHandler: (data) => {
            setGridData((prev) =>
              prev.map((item) => {
                if (item.id === params.data.id) {
                  if (item.persisted) {
                    return {
                      ...item,
                      chdStatus: data,
                      mode: mode.EDIT,
                    };
                  } else {
                    return {
                      ...item,
                      chdStatus: data,
                    };
                  }
                }
                return item;
              }),
            );
          },
          options: statusOpt,
          placeholder: "Select Status",
          module: MODULES.Finance,
          form: DETAIL_FORM,
          field: "chdStatus",
          authenticated: true,
          value: params.data.chdStatus,
          disabled: approvalMode,
        }),
      },
      // {
      //   headerName: "Active",
      //   field: "chdActive",
      //   module: MODULES.Finance,
      //   primaryForm: DETAIL_FORM,
      //   authenticated: true,
      //   cellRenderer: SelectRenderer,
      //   cellRendererParams: (params) => ({
      //     onChangeHandler: (data) => {
      //       setGridData((prev) =>
      //         prev.map((item) => {
      //           if (item.id === params.data.id) {
      //             if (item.persisted) {
      //               return {
      //                 ...item,
      //                 chdActive: data,
      //                 mode: mode.EDIT,
      //               };
      //             } else {
      //               return {
      //                 ...item,
      //                 chdActive: data,
      //               };
      //             }
      //           }
      //           return item;
      //         }),
      //       );
      //     },
      //     options: activeOpt,
      //     placeholder: "Select Active",
      //     module: MODULES.Finance,
      //     form: DETAIL_FORM,
      //     field: "chdActive",
      //     authenticated: true,
      //     value: params.data.chdActive,
      //     disabled: approvalMode,
      //   }),
      // },
      {
        field: "chdDelete",
        cellRenderer: ButtonRenderer,
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellRendererParams: (params) => {
          console.log(params);
          return {
            clickHandler: () => {
              setGridData((prev) =>
                prev.filter((item) => item.id !== params.data.id),
              );
              setRowCount((prev) => prev - 1);
            },
            label: "Delete",
            className: "ui red button",
            module: MODULES.Finance,
            form: DETAIL_FORM,
            editMode: params.data.chdId !== null && isNumber(params.data.chdId),
            authenticated: true,
            authType: AUTHORITY_TYPE.FORM,
            consider: AUTH_TYPES.DELETE,
            disabled: approvalMode,
          };
        },
      },
    ];
    if (containsAnyGridPermissions()) {
      configData.push({
        headerCheckboxSelection: true,
        checkboxSelection: containsAnyGridPermissions(),
        field: "",
        pinned: "left",
        minWidth: 50,
        width: 50,
      });
    }
    return configData;
  };

  const getApprovalModeConfig = () => {
    const configData = [
      {
        headerName: "Charge",
        field: "chdChacrges",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellRenderer: SelectRenderer,
        cellRendererParams: (params) => ({
          onChangeHandler: (data) => {
            setGridData((prev) =>
              prev.map((item) => {
                if (item.id === params.data.id) {
                  if (item.persisted) {
                    return {
                      ...item,
                      chdChacrges: data,
                      mode: mode.EDIT,
                    };
                  } else {
                    return {
                      ...item,
                      chdChacrges: data,
                    };
                  }
                }
                return item;
              }),
            );
          },
          options: chargeOpt,
          placeholder: "Select Charge",
          module: MODULES.Finance,
          form: DETAIL_FORM,
          field: "chdChacrges",
          authenticated: true,
          value: params.data.chdChacrges,
          disabled: approvalMode,
          pinned: "left",
        }),
      },
      {
        headerName: "Charge Type",
        field: "chdChargeType",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellRenderer: SelectRenderer,
        cellRendererParams: (params) => {
          return {
            module: MODULES.Finance,
            form: DETAIL_FORM,
            field: "chdChargeType",
            authenticated: true,
            options: revCostOpt,
            placeholder: "Select Charge Type",
            value: params.data.chdChargeType,
            disabled: true,
          };
        },
      },
      {
        headerName: "Description",
        field: "chdDescription",
        cellEditor: "agTextCellEditor",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellEditorParams: {
          maxLength: 100,
        },
        editable: false,
        cellRenderer: ResizableScrollingTextRenderer,
        minWidth: 300,
      },
      {
        headerName: "Value",
        field: "chdValue",
        cellEditor: "agNumberCellEditor",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        editable: false,
        cellRenderer: DynamicCurrencyRenderer,
        cellRendererParams: (params) => ({
          currencyCode: userCurrencyCode,
        }),
      },
      {
        headerName: "Qty",
        field: "chdQty",
        cellEditor: "agNumberCellEditor",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        editable: false,
        // valueFormatter: (params) => {
        //   const value = params.value || 1; //
        //   return value.toFixed(2); // Always display with 2 decimal places
        // },
      },
      {
        headerName: "Total",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        field: "chdTotal",
        cellRenderer: DynamicCurrencyRenderer,
        cellRendererParams: (params) => ({
          currencyCode: userCurrencyCode,
        }),
      },
      {
        headerName: "Tax Amount",
        field: "chdTaxAmount",
        cellEditor: "agNumberCellEditor",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: false,
        cellRenderer: DynamicCurrencyRenderer,
        cellRendererParams: (params) => ({
          currencyCode: userCurrencyCode,
        }),
      },
      {
        headerName: "UOM",
        field: "chdUom",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellRenderer: SelectRenderer,
        cellRendererParams: (params) => ({
          onChangeHandler: (data) => {
            setGridData((prev) =>
              prev.map((item) => {
                if (item.id === params.data.id) {
                  if (item.persisted) {
                    return {
                      ...item,
                      chdUom: data,
                      mode: mode.EDIT,
                    };
                  } else {
                    return {
                      ...item,
                      chdUom: data,
                    };
                  }
                }
                return item;
              }),
            );
          },
          options: uomOpt,
          placeholder: "Select UOM",
          module: MODULES.Finance,
          form: DETAIL_FORM,
          field: "chdUom",
          authenticated: true,
          value: params.data.chdUom,
          disabled: approvalMode,
        }),
      },
      {
        headerName: "Status",
        field: "chdStatus",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellRenderer: SelectRenderer,
        cellRendererParams: (params) => ({
          onChangeHandler: (data) => {
            setGridData((prev) =>
              prev.map((item) => {
                if (item.id === params.data.id) {
                  if (item.persisted) {
                    return {
                      ...item,
                      chdStatus: data,
                      mode: mode.EDIT,
                    };
                  } else {
                    return {
                      ...item,
                      chdStatus: data,
                    };
                  }
                }
                return item;
              }),
            );
          },
          options: statusOpt,
          placeholder: "Select Status",
          module: MODULES.Finance,
          form: DETAIL_FORM,
          field: "chdStatus",
          authenticated: true,
          value: params.data.chdStatus,
          disabled: approvalMode,
        }),
      },
      {
        headerName: "Active",
        field: "chdActive",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellRenderer: SelectRenderer,
        cellRendererParams: (params) => ({
          onChangeHandler: (data) => {
            setGridData((prev) =>
              prev.map((item) => {
                if (item.id === params.data.id) {
                  if (item.persisted) {
                    return {
                      ...item,
                      chdActive: data,
                      mode: mode.EDIT,
                    };
                  } else {
                    return {
                      ...item,
                      chdActive: data,
                    };
                  }
                }
                return item;
              }),
            );
          },
          options: activeOpt,
          placeholder: "Select Active",
          module: MODULES.Finance,
          form: DETAIL_FORM,
          field: "chdActive",
          authenticated: true,
          value: params.data.chdActive,
          disabled: approvalMode,
        }),
      },
    ];

    return configData;
  };

  const cellDoubleClickHandler = (params) => {
    // if (isDisabled(params)) return;

    console.log("params", params);
    switch (params.colDef.headerName) {
      case "Currency": {
        setRowData(params.data);
        setExchangeRate({
          key: params.data.chdExcCurrency?.excId,
          text: params.data.chdExcCurrency?.curCode,
          value: JSON.stringify(params.data.chdExcCurrency),
        });
        openModal2();
        break;
      }
      default:
        break;
    }
  };

  const onCurrencyHandler = (data) => {
    console.log("param data", data.value);
    const parsedData = data.value ? JSON.parse(data.value) : {};

    if (rowData.chdChargeType) {
      if (
        parseInt(rowData.chdChargeType) === 2 &&
        chargeHeader?.chhEvStatus === 3
      ) {
        setChargeHeader((prevState) => ({
          ...prevState,
          evModified: true,
        }));
      } else if (
        parseInt(rowData.chdChargeType) === 1 &&
        chargeHeader?.chhInvStatus === 3
      ) {
        setChargeHeader((prevState) => ({
          ...prevState,
          invModified: true,
        }));
      }
    }
    setGridData((prev) =>
      prev.map((item) => {
        if (item.id === rowData.id) {
          if (item.persisted) {
            return {
              ...item,
              chdExcCurrency: parsedData,
              chdExcId: parsedData?.excId,
              chdExcRate: parsedData?.excRate,
              chdTotal: item.chdQty * item.chdValue * parsedData?.excRate,
              mode: mode.EDIT,
            };
          } else {
            return {
              ...item,
              chdExcCurrency: parsedData,
              chdExcId: parsedData?.excId,
              chdExcRate: parsedData?.excRate,
              chdTotal: item.chdQty * item.chdValue * parsedData?.excRate,
            };
          }
        }
        return item;
      }),
    );

    setExchangeRate({});
    setRowData({});
    closeModal2();
  };

  const handleDownload = () => {
    dispatch(
      reportActions.setEvInvoiceReportData({
        jobInfo: jobData,
        fetchedResponse: evInvDetails,
        moduleCategory:
          evInv === 4
            ? evInvDetails?.eihSingleBulk === 1
              ? 2
              : 4
            : evInvDetails?.eihSingleBulk === 1
              ? 3
              : 5,
      }),
    );
    modal3Ref.current?.showModal();
  };

  const formatter = useMemo(
    () =>
      userCurrencyCode
        ? Intl.NumberFormat("en-US", {
            style: "currency",
            currency: userCurrencyCode,
          })
        : null,
    [userCurrencyCode],
  );

  return (
    <>
      {isBlurred && (
        <div className="blur-overlay">
          <LoadingSpinner
            message={
              approvalMode
                ? `Approving ${evInvDetails?.eihCode}...`
                : `Generating ${evInv === modeObj.EV ? "EV" : "INV"}...`
            }
          />
        </div>
      )}

      <Modal ref={modal3Ref} closeButton={true} minHeight="500px">
        <JobMonitorReportComponent evinv={true} />
      </Modal>

      <div className="drawer-content">
        <div className="ui top attached tabular menu">
          <div
            className={`item ${drawerTab === 1 ? "active" : ""}`}
            onClick={() => {
              setDrawerTab(1);
            }}
          >
            <span>
              <DollarSign
                size={15}
                style={{
                  marginRight: "5px",
                }}
              />
            </span>
            <label>Pick Charges</label>
          </div>

          <div
            className={`item ${drawerTab === 2 ? "active" : ""}`}
            onClick={() => {
              setDrawerTab(2);
            }}
          >
            <span>
              <Upload
                size={15}
                style={{
                  marginRight: "5px",
                }}
              />
            </span>
            <label>Document Upload</label>
          </div>
        </div>

        <div
          className="ui bottom attached active tab segment"
          style={{ display: drawerTab === 1 ? "block" : "none" }}
        >
          {isLoading || templateDetailsLoading || isJobInfoLoading ? (
            <LoadingSpinner />
          ) : (
            <>
              <InfoList content={JobSummary} title={"Job Summary"} />
              {gridData?.length > 0 && (
                <ChargeTaxBreakdown
                  formatter={formatter}
                  selectedCharge={selectedCharge ? selectedCharge : null}
                />
              )}
              <div className="ui form segment">
                <div
                  style={{
                    display: approvalMode ? "none" : "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Button
                    onClick={handleAddRow}
                    disabled={
                      (chargeHeader.chhEvStatus === 3 &&
                        chargeHeader.chhInvStatus === 3) ||
                      approvalMode
                    }
                    module={MODULES.Finance}
                    form={DETAIL_FORM}
                    authenticated={true}
                    editMode={editMode}
                    Icon={Plus}
                    label="Add"
                  />
                  <Button
                    onClick={openModal}
                    disabled={
                      !saveAsTemplatePermission ||
                      gridData.length === 0 ||
                      selectedRows.length === 0 ||
                      approvalMode
                    }
                    editMode={editMode}
                    Icon={Save}
                    label="SAVE AS TEMPLATE"
                  />
                </div>

                <div className="ui form">
                  <div className="three fields">
                    {approvalMode ? (
                      <Input
                        type={"text"}
                        label={"EV/INV number"}
                        readOnly={true}
                        value={evInvNo}
                      />
                    ) : (
                      ""
                    )}
                    {approvalMode ? (
                      <Input
                        type={"date"}
                        label={"Date"}
                        readOnly={true}
                        value={createdDate}
                      />
                    ) : (
                      ""
                    )}

                    <Input
                      type={"text"}
                      label={"Reference"}
                      placeholder={"Reference"}
                      value={reference}
                      onChange={(e) => setReference(e.target.value)}
                    />
                  </div>

                  {approvalMode ? (
                    <div className="three fields">
                      <Input
                        type={"text"}
                        label={"Without Tax"}
                        readOnly={true}
                        value={withoutTax}
                      />
                      <Input
                        type={"text"}
                        label={"Tax"}
                        readOnly={true}
                        value={tax}
                      />
                      <Input
                        type={"text"}
                        label={"Total"}
                        readOnly={true}
                        value={total}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                <Grid
                  ref={gridRef}
                  searchable={false}
                  module={MODULES.Finance}
                  multiRowSelection={containsAnyGridPermissions()}
                  //   showDownloadButton={chargeDetailPermissions?.FORM?.DOWNLOAD}
                  downloadOnlySelected={true}
                  heading="Add Charges"
                  stopEditingWhenCellsLoseFocus={true}
                  onSelectionChanged={handleSelectionChanged}
                  onCellEditingStopped={cellEditorParams}
                  onCellDoubleClicked={cellDoubleClickHandler}
                  content={gridData}
                  config={approvalMode ? getApprovalModeConfig() : getConfig()}
                  cellClickHandler={(e) => {
                    setSelectedCharge({
                      jobEvInvoicesTaxDetailList: e.data.taxList,
                    });
                  }}
                />
              </div>
            </>
          )}
        </div>

        <div
          className="ui bottom attached active tab segment"
          style={{ display: drawerTab === 2 ? "block" : "none" }}
        >
          <DocumentUpload
            isLoading={isLoading}
            opeType={17}
            module={MODULES.Finance}
            ref={documentRef}
            reference={evInvDetails?.eihId}
            dropdown={{
              documentTypeOptions: documentTypeOptions,
              statusOptions: statusOpt,
              fileNameOptions: fileNameOptions,
              activeOptions: activeOpt,
            }}
            editMode={approvalMode}
            currentValues={
              approvalMode && documents !== null ? documents : null
            }
          />
        </div>

        {isLoading || templateDetailsLoading || isJobInfoLoading ? (
          <></>
        ) : (
          <div
            style={{
              width: "100%",
              display: approvalMode ? "flex" : "none",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Dropdown
              label="Approve or Reject"
              options={statusOpt}
              value={approveStatus}
              clearable={false}
              onChange={(e, data) => setApproveStatus(data.value)}
              placeholder="Select Status"
              // disabled={!evInvApprovalDetailPermission}
            />
            <Button
              label="Download EV/INV"
              onClick={handleDownload}
              disabled={!approvalMode}
              Icon={Download}
            />
            <Button
              type="submit"
              label={"Approve/Reject"}
              onClick={(e) => approveEvInvInAdHocManner(e)}
              disabled={approveStatus === 1}
              Icon={MdApproval}
              isLoading={isSubmitLoading}
            />
          </div>
        )}

        <div
          style={{
            width: "100%",
            display: !approvalMode ? "flex" : "none",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Button
            type="submit"
            template="create"
            isLoading={isSubmitLoading}
            module={MODULES.Finance}
            form={HEADER_FORM}
            authenticated={true}
            editMode={editMode}
            onClick={(e) => {
              generateEvInvInAdHoc(e);
            }}
            disabled={!(gridData.length > 0 && selectedRows.length > 0)}
          />
        </div>
      </div>
      <Modal ref={modalRef} minHeight="50vh" minWidth="50vw">
        <form className="ui form segment">
          <div className="two fields">
            <Input
              type="text"
              label="Template Name"
              placeholder="Template Name"
              required={true}
              value={templateName}
              onChange={(e) => {
                setTemplateName(e.target.value);
              }}
              error={currentErrors.intTemplateName}
              resetError={() =>
                setCurrentErrors((prevState) => {
                  const { intTemplateName: _, ...rest } = prevState;
                  return rest;
                })
              }
            />
            <Dropdown
              label="Category"
              required={true}
              clearable
              placeholder="Select Category"
              options={customerSupplierOpt}
              value={category}
              onChange={(e, data) => setCategory(data.value)}
              error={currentErrors.intCategory}
              resetError={() =>
                setCurrentErrors((prevState) => {
                  const { intCategory: _, ...rest } = prevState;
                  return rest;
                })
              }
            />
          </div>

          <div className="field">
            <Input
              type="text"
              label="Description"
              placeholder="Description"
              value={templateDescription}
              onChange={(e) => {
                setTemplateDescription(e.target.value);
              }}
            />
          </div>

          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <div className="field" style={{ width: "100%" }}>
              <Button
                type="submit"
                template="create"
                isLoading={savingTemplate}
                onClick={(e) => {
                  saveAsTemplate(e);
                }}
              />
            </div>
          </div>
        </form>
      </Modal>

      <Modal
        ref={modal2Ref}
        closeButton={false}
        minWidth={"50vw"}
        minHeight={"50vh"}
      >
        <div
          className="ui form segment"
          style={{ height: "50vh", margin: "20px" }}
        >
          <Dropdown
            label="Currency"
            clearable={false}
            search={true}
            placeholder="Select Currency"
            options={exchangeRates}
            value={JSON.stringify(rowData.chdExcCurrency)}
            onChange={(e, data) => setExchangeRate(data)}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: "5px",
            paddingBottom: "5px",
            gap: "5px",
          }}
        >
          <Button Icon={X} label={"Cancel"} onClick={closeModal2} color="red" />
          <Button
            Icon={Check}
            label={"Ok"}
            onClick={() => onCurrencyHandler(exchangeRate)}
          />
        </div>
      </Modal>
    </>
  );
};

export default JobMonitorEvInvCreation;

const styles = `
  .blur-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    z-index: 9999; /* Ensure it's on top of everything */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .blurred {
    filter: blur(5px); /* Blur effect on content */
    pointer-events: none; /* Prevent interaction with blurred content */
  }
`;

document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
